<template>
  <div class="bg-black w-full sm:max-w-368 px-16 sm:px-0">
    <p v-if="isEdit" class="text-h3 mt-16">Edit surcharge</p>
    <p class="text-body pt-16 mb-16">For your materials, time, and expertise</p>
    <div class="md:px-16 md:py-24 md:rounded md:bg-white">
      <p class="text-center text-h4 mb-32">{{ surchargeLabel }}</p>
      <div class="mb-36">
        <slider
          v-if="maxSurcharge"
          v-model="sliderValue"
          :min="minSurcharge"
          :max="maxSurcharge"
          prefix="$"
          suffix=" per child"
        />
      </div>
      <div class="flex justify-between pb-8 border-b-1 border-solid border-grey-divider-subdued">
        <p class="text-body">Subtotal</p>
        <p class="text-grey-text-subdued">${{ subtotal }}</p>
      </div>
      <div class="flex justify-between py-8 border-b-1 border-solid border-grey-divider-subdued">
        <p class="text-body">Surcharge</p>
        <p class="text-grey-text-subdued" aria-hidden="true">{{ surchargeListLabel }}</p>
        <p class="sr-only">{{ surchargeLabel }}</p>
      </div>
      <div class="flex justify-between text-strong-body pt-8 mb-24">
        <p>Base total for 1 child</p>
        <p>${{ totalRate }}</p>
      </div>
      <Button :value="isEdit ? 'Save' : 'Next'" size="medium" class="w-full mb-16" @click="setSurcharge" />
    </div>
  </div>
</template>

<script lang="ts">
import slider from '../../../components/slider/slider.vue';
import Button from '../../../components/button/Button.vue';

export default {
  name: 'Surcharge',
  components: { slider, Button },
  props: {
    adventureMetaData: { type: Object, default: () => {} },
    subtotal: { type: Number, default: 0 },
    isEdit: Boolean,
  },
  data(): any {
    return {
      sliderValue:
        this.$store.getters['adventures/adventureDraft'].surcharge > 0
          ? this.$store.getters['adventures/adventureDraft'].surcharge / 100
          : 5,
    };
  },
  computed: {
    minSurcharge(): number {
      return this.findConstraint('SURCHARGE').min / 100;
    },
    maxSurcharge(): number {
      return this.findConstraint('SURCHARGE').max / 100;
    },
    totalRate(): number {
      return Number(this.sliderValue) + Number(this.subtotal);
    },
    surchargeLabel(): string {
      return `$${this.sliderValue} per child`;
    },
    surchargeListLabel(): string {
      return `$${this.sliderValue}/child`;
    },
  },
  methods: {
    async setSurcharge() {
      this.$emit('close');
      await this.$store.dispatch('adventures/updateStore', { surcharge: this.sliderValue * 100 });
      this.$router.push({
        path: this.isEdit ? `/adventures/${this.$store.getters['adventures/adventureId']}/edit` : '/adventures/new/photo',
      });
    },
    findConstraint(field: string) {
      return this.adventureMetaData?.constraints.find((constraint) => constraint.field === field) || {};
    },
  },
};
</script>
